import type { Langcodes } from '@uncinc/react-drupal-core/types';
import type { MenuItem } from 'instantsearch.js/es/connectors/menu/connectMenu';

export interface Weight {
  id: number;
  weight: number;
  value: string;
}

export default function sortSearchItemsByWeight(items: MenuItem[], weights: [Weight, ...Weight[]], langcode: Langcodes): MenuItem[] {
  const itemsWithWeights = items.map((item) => {
    const matchingOrder = weights.find((o) => o.id === Number(item.value));
    const categoryName = weights[Number(item.value)]?.value.split('/');

    return {
      ...item,
      label: categoryName?.[langcode === 'en' ? 0 : 1] ?? '',
      weight: matchingOrder?.weight ?? items.length,
    };
  });

  return itemsWithWeights.sort((a, b) => a.weight - b.weight);
}
